import { createFileRoute } from "@tanstack/react-router";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/outcome/$questionnaireId/answers",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="outcomeAnswers" />
      <div>Hello "/$organizationKey/$dossierId/outcome/$questionnaireid/answers"!</div>
    </>
  );
}
